module.exports = function() {
  return new Worker(__webpack_public_path__ + "027a1f043c775a39fdf9.worker.js");
};